import React from "react";
import { VisuallyHidden } from "react-aria";
import { t } from "ttag";

import { SuiteSnapshotBlock as Value } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Clickable } from "../Clickables";
import { Svg } from "../Svg";

import styles from "./SuiteSnapshotBlock.module.scss";

export const SuiteSnapshotBlock = ({
    value,
    id,
    className,
    cta,
}: {
    value: Value;
    id?: string;
    className?: string;
    cta?: () => void;
}) => {
    if (!value.images || value.images.length === 0) return <></>;

    const Tag = value.caption ? "figure" : "div";

    return (
        <Tag
            className={concatClassNames([styles.root, className])}
            aria-hidden={value.caption || cta ? undefined : "true"}
        >
            {value.images.map((image, i) => (
                <React.Fragment key={`${id}-${i}`}>
                    {i > 0 && (
                        <div className={styles.spacer} aria-hidden="true" />
                    )}
                    <ImageChooserBlock
                        value={image}
                        attrs={{ className: styles.circle }}
                        imageAttrs={{ className: styles.image }}
                        sizes={styles.sizes}
                    />
                </React.Fragment>
            ))}
            <div className={styles.spacer} aria-hidden="true" />
            {cta ? (
                <Clickable className={styles.plusCircle} onClick={cta}>
                    <Svg
                        name="plus"
                        visuallyHiddenText={t`Get started`}
                        className={styles.plusIcon}
                    />
                </Clickable>
            ) : (
                <div className={styles.plusCircle}>
                    <Svg
                        name="plus"
                        aria-hidden="true"
                        className={styles.plusIcon}
                    />
                </div>
            )}
            {value.caption && (
                <VisuallyHidden elementType="figcaption">
                    {value.caption}
                </VisuallyHidden>
            )}
        </Tag>
    );
};
